/**
 * LIORA — guide des tailles en modale.
 *
 * Les liens vers /pages/guide-des-tailles se trouvent dans les descriptions
 * produit et dans les rangees d'information. Plutot que d'envoyer la cliente sur
 * une autre page en pleine hesitation d'achat, on ouvre le contenu par-dessus la
 * fiche.
 *
 * PRINCIPE : le <dialog> est rendu cote serveur avec le contenu de la page, il
 * n'y a donc rien a charger. On intercepte le clic, et si quoi que ce soit
 * manque — script non charge, <dialog> absent, navigateur ancien — le lien
 * fonctionne normalement et mene a la page. Aucun cul-de-sac possible.
 *
 * Le focus, la fermeture par Echap et l'inertie de l'arriere-plan sont pris en
 * charge par showModal(). On n'ajoute que la fermeture au clic sur le fond, que
 * <dialog> ne fait pas de lui-meme.
 */

const SELECTOR = 'a[href*="/pages/guide-des-tailles"]';

/** @returns {HTMLDialogElement | null} */
function getDialog() {
  const el = document.getElementById('liora-size-guide');
  return el instanceof HTMLDialogElement && typeof el.showModal === 'function' ? el : null;
}

document.addEventListener('click', (event) => {
  const target = event.target;
  if (!(target instanceof Element)) return;

  const link = target.closest(SELECTOR);
  if (!link) return;

  // Laisser passer les ouvertures volontaires dans un nouvel onglet.
  if (event.metaKey || event.ctrlKey || event.shiftKey || event.button !== 0) return;

  const dialog = getDialog();
  if (!dialog) return; // repli : navigation normale vers la page

  event.preventDefault();
  dialog.showModal();
});

document.addEventListener('click', (event) => {
  const target = event.target;
  if (!(target instanceof Element)) return;

  const dialog = getDialog();
  if (!dialog || !dialog.open) return;

  if (target.closest('[data-sg-close]')) {
    dialog.close();
    return;
  }

  // Clic sur le fond : la cible est le <dialog> lui-meme, jamais son contenu,
  // puisque le contenu est enveloppe dans un conteneur interne.
  if (target === dialog) dialog.close();
});
